"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _cssClassesHelper = require("../../../../../helpers/cssClassesHelper");
var _ThemeFormComponent = _interopRequireDefault(require("./ThemeFormComponent"));
var _APLabelWithText = _interopRequireDefault(require("../../../../common/APLabelWithText"));
var _APButton = _interopRequireDefault(require("../../../../common/APButton"));
var _Modal = _interopRequireDefault(require("../../../../common/Modal/Modal"));
var _ThemeContext = require("../../../../Theme/ThemeContext");
var _ChartEnums = require("./ChartEnums");
require("./ThemeSettingsComponent.css");
var _config = _interopRequireDefault(require("../../../../../config"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
var themeClasses = (0, _cssClassesHelper.getBEMClasses)('theme-settings');
var ThemeSettingsComponent = function ThemeSettingsComponent() {
  var _useTranslation = (0, _reactI18next.useTranslation)("user"),
    t = _useTranslation.t;
  var _useState = (0, _react.useState)(false),
    _useState2 = _slicedToArray(_useState, 2),
    openModal = _useState2[0],
    setOpenModal = _useState2[1];
  var _useTheme = (0, _ThemeContext.useTheme)(),
    theme = _useTheme.theme,
    changeTheme = _useTheme.changeTheme;
  console.log(theme);
  var submitForm = (0, _react.useCallback)(function (formValues) {
    changeTheme(formValues.theme);
    localStorage.setItem('apexTemplate', JSON.stringify(_objectSpread(_objectSpread({}, JSON.parse(localStorage.getItem('apexTemplate')) || {}), formValues)));
    _config["default"].TradingLayout.chart = formValues.chart;
    setOpenModal(false);
  }, [changeTheme]);
  return /*#__PURE__*/_react["default"].createElement("div", {
    className: themeClasses('main')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: themeClasses('body')
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: themeClasses('row')
  }, /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    label: t('Color Theme'),
    text: theme,
    customClass: themeClasses()
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: themeClasses('row')
  }, /*#__PURE__*/_react["default"].createElement(_APLabelWithText["default"], {
    label: t('Chart'),
    text: t(_ChartEnums.chartEnums[_config["default"].TradingLayout.chart]),
    customClass: themeClasses()
  })), /*#__PURE__*/_react["default"].createElement("div", {
    className: themeClasses('button-container')
  }, /*#__PURE__*/_react["default"].createElement(_APButton["default"], {
    customClass: themeClasses(),
    onClick: function onClick() {
      return setOpenModal(true);
    }
  }, t('Edit'))), openModal && /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
    isOpen: openModal,
    title: t('Edit Theme'),
    onCancel: function onCancel() {
      return setOpenModal(false);
    },
    close: function close() {
      return setOpenModal(false);
    },
    customClass: themeClasses('ap-modal')
  }, /*#__PURE__*/_react["default"].createElement(_ThemeFormComponent["default"], {
    initialValues: {
      chart: _config["default"].TradingLayout.chart,
      theme: theme
    },
    onSubmit: submitForm
  }))));
};
ThemeSettingsComponent.propTypes = {
  formValues: _propTypes["default"].object.isRequired
};
var _default = exports["default"] = ThemeSettingsComponent;